import * as React from 'react';
import { useEffect, useState } from 'react';
import { Box, Container, Header, KeyValuePairs, Textarea } from '@amzn/awsui-components-react-v3';
import { deleteNotificationTemplate, getNotificationTemplate } from 'src/api/notifications';
import { Page } from 'src/routes';
import { TABLE_CONTENT_TYPE } from 'src/commons/constants';

import { PageHeader } from 'src/components/common/PageHeader';
import { CommonPageProps } from 'src/components/common/CommonPageProps';

export interface NotificationTemplateDetailProps extends CommonPageProps {}

export const NotificationTemplateDetail = (props: NotificationTemplateDetailProps) => {
  const [template, setTemplate] = useState({});

  const handleRefresh = async () => {
    if (!props.activeGroup) return;
    const template = await getNotificationTemplate({
      NotificationTemplateId: props.match.params.NotificationTemplateId,
      NotificationOwnerId: props.activeWorkspace ? props.activeWorkspace.workspaceId : props.activeGroup,
    });
    setTemplate(template.NotificationTemplate);
  };

  useEffect(() => {
    props.setContentType(TABLE_CONTENT_TYPE);
    handleRefresh();
  }, []);

  const handleDelete = async () => {
    await deleteNotificationTemplate({
      NotificationTemplateId: props.match.params.NotificationTemplateId,
      NotificationOwnerId: props.activeWorkspace ? props.activeWorkspace.workspaceId : props.activeGroup,
    });
    props.setRedirect(Page.NOTIFICATION_TEMPLATES);
  };

  const handleUpdate = async () => {
    props.setRedirect('/notificationtemplates/' + props.match.params.NotificationTemplateId + '/update');
  };

  return (
    <>
      {props.activeGroup == template['OwnerGroupId'] && (
        <PageHeader
          buttons={[
            {
              text: '',
              icon: 'refresh',
              onItemClick: handleRefresh,
            },
            {
              text: 'Edit',
              onItemClick: handleUpdate,
            },
            { text: 'Delete', onItemClick: handleDelete },
          ]}
          header='Notification template details'
        />
      )}
      <Container header={<Header variant={'h2'}>Details</Header>}>
        <KeyValuePairs
          columns={4}
          items={[
            { label: 'ID', value: template['NotificationTemplateId'] },
            { label: 'Template name', value: template['NotificationTemplateName'] },
            { label: 'Owner group', value: template['OwnerGroupId'] },
          ].filter((item) => item != undefined)}
        />
        <div>
          <Box variant='h2'>Template content</Box>
          <Textarea value={template['Content']} rows={10} readOnly />
        </div>
      </Container>
    </>
  );
};
